import { fetcher } from '#lib/backendFetcher';

const BASE = '/api/v1/platform/api-access/api-keys';

/**
 * Fetches all API keys of the authenticated user's org.
 *
 * @returns {Promise<{apiKeys: Array<object>}>}
 */
export const getApiKeys = async () => {
	return fetcher(BASE, { method: 'GET' });
};

/**
 * Creates a new API key. The plaintext secret is returned ONCE and must be shown immediately.
 *
 * @param {object} data
 * @param {string} data.name - Human-readable label (unique per org).
 * @param {string[]} data.scopes - Granted scopes.
 * @param {string|null} [data.expiresAt] - Optional ISO expiry.
 * @returns {Promise<{apiKey: {id: string, name: string, prefix: string, scopes: string[], plaintext: string, createdAt: string}}>}
 */
export const createApiKey = async (data) => {
	return fetcher(BASE, { method: 'POST', body: data });
};

/**
 * Revokes an API key by id.
 *
 * @param {string} keyId - The key id.
 * @returns {Promise<void>}
 */
export const revokeApiKey = async (keyId) => {
	return fetcher(`${BASE}/${keyId}`, { method: 'DELETE' });
};
